import { render } from "./GameArea.vue?vue&type=template&id=1cd22135"
import script from "./GameArea.vue?vue&type=script&lang=js"
export * from "./GameArea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__